export default "__VITE_ASSET__Cvw_24oj__"